export const DEFAULT_PRESELECTED_COMBINATIONS = {
  lithium: [
    {
      category: 'Lithium Carbonate',
      priceType: 'Daily Price Indicator',
      purity: '99.50%',
    },
    {
      category: 'Lithium Carbonate',
      purity: 'Min 99.5%',
      shippingRoute: 'EXW China',
    },
    {
      category: 'Lithium Carbonate',
      purity: 'Min 99.2%',
      shippingRoute: 'CIF Asia (spot)',
    },
    {
      category: 'Lithium Carbonate',
      purity: 'Min 99.0%',
      shippingRoute: 'CIF Asia (spot)',
    },
    {
      category: 'Lithium Hydroxide',
      purity: 'Min 56.5%',
      shippingRoute: 'EXW China',
    },
    {
      category: 'Lithium Hydroxide',
      purity: 'Min 56.5%',
      shippingRoute: 'CIF Asia (spot)',
    },
    {
      category: 'Spodumene',
      purity: '6%',
      shippingRoute: 'FOB Australia',
    },
  ],
  cobalt: [
    {
      category: 'Cobalt Hydroxide',
      purity: 'Min 20%',
      shippingRoute: 'CIF Asia',
    },
    {
      category: 'Cobalt Metal',
      purity: 'Min 99.8%',
      shippingRoute: 'EXW Europe',
    },
    {
      category: 'Cobalt Sulphate',
      purity: 'Min 20.5%',
      shippingRoute: 'EXW China',
    },
  ],
  nickel: [
    {
      category: 'Nickel Sulphate',
      purity: '100% Ni Contained',
      shippingRoute: 'CIF Asia',
    },
    {
      category: 'Nickel Sulphate',
      purity: 'Min 22%',
      shippingRoute: 'EXW China',
    },
    {
      category: 'Nickel Metal',
      purity: 'Min 99.8%',
      shippingRoute: 'EXW Europe',
    },
    {
      category: 'Mixed Hydroxide Precipitate',
      purity: 'Min 35%',
      shippingRoute: 'CIF Asia',
    },
  ],
  'natural-graphite': [
    {
      category: 'Flake',
      meshSize: '-100 mesh',
      purity: '94-95% C',
      shippingRoute: 'CIF N America',
    },
    {
      category: 'Flake',
      meshSize: '+100 mesh',
      purity: '94-95% C',
      shippingRoute: 'FOB China',
    },
    {
      category: 'Flake',
      meshSize: '+100 mesh',
      purity: '90-93% C',
      shippingRoute: 'FOB China',
    },
    {
      category: 'Spherical Uncoated',
      meshSize: '15 microns',
      purity: '99.95%',
      shippingRoute: 'FOB China',
    },
  ],
  'synthetic-graphite': [
    {
      category: 'Pre-calcined Pet Coke',
      purity: 'S<0.5%',
      shippingRoute: 'DDP China',
    },
    {
      category: 'Medium Sulphur Pre-calcined Pet Coke',
      purity: '0.5%<S<3.0%',
      shippingRoute: 'DDP China',
    },
    {
      category: 'Pre-calcined Pet Needle Coke',
      purity: 'S<0.5%',
      shippingRoute: 'DDP China',
    },
  ],
  anode: [
    {
      category: 'Natural Graphite Anode',
      purity: 'High (360-370 mAh/g), min 99.97% C',
      shippingRoute: 'DDP China',
    },
    {
      category: 'Natural Graphite Anode',
      purity: 'Medium (360-370 mAh/g), min 99.95% C',
      shippingRoute: 'DDP China',
    },
    {
      category: 'Natural Graphite Anode',
      purity: 'Low (345-360 mAh/g), min 99.90% C',
      shippingRoute: 'DDP China',
    },
    {
      category: 'Synthetic Graphite Anode',
      purity: 'High (350-370 mAh/g), min 99.97% C',
      shippingRoute: 'DDP China',
    },
    {
      category: 'Synthetic Graphite Anode',
      purity: 'Medium (330-350 mAh/g), min 99.95% C',
      shippingRoute: 'DDP China',
    },
    {
      category: 'Synthetic Graphite Anode',
      purity: 'Low (310-330 mAh/g), min 99.70% C',
      shippingRoute: 'DDP China',
    },
  ],
  cathode: [
    {
      category: 'LFP, ≥160 mAh/g',
      shippingRoute: 'DDP China',
    },
    {
      category: 'NCM523, 150-170 mAh/g',
      shippingRoute: 'DDP China',
    },
    {
      category: 'NCM613, 170-200 mAh/g',
      shippingRoute: 'DDP China',
    },
    {
      category: 'NCM811, ≥200 mAh/g',
      shippingRoute: 'DDP China',
    },
  ],
  'lithium-ion-batteries': [
    {
      category: 'NCM111',
      format: 'Pouch',
      shippingRoute: 'EXW Asia',
    },
    {
      category: 'NCM523',
      format: 'Pouch',
      shippingRoute: 'EXW Asia',
    },
    {
      category: 'NCM622',
      format: 'Pouch',
      shippingRoute: 'EXW Asia',
    },
    {
      category: 'NCM811',
      format: 'Pouch',
      shippingRoute: 'EXW Asia',
    },
    {
      category: 'NCA',
      format: 'Pouch',
      shippingRoute: 'EXW Asia',
    },
    {
      category: 'LFP',
      format: 'Prismatic',
      shippingRoute: 'EXW China',
    },
    {
      category: 'LCO',
      format: 'Pouch',
      shippingRoute: 'EXW Asia',
    },
  ],
  'black-mass': [
    {
      feedstock: 'LCO',
      product: 'LCE',
      shippingRoute: 'EXW China',
    },
    {
      feedstock: 'LFP',
      product: 'Li Price per Percentage Point',
      shippingRoute: 'EXW China',
    },
    {
      feedstock: 'NCM',
      product: 'Ni',
      shippingRoute: 'EXW North America',
    },
    {
      feedstock: 'NCM',
      product: 'Ni',
      shippingRoute: 'CIF Asia',
    },
    {
      feedstock: 'NCM',
      product: 'Ni',
      shippingRoute: 'EXW Europe',
    },
  ],
  'rare-earths': [
    {
      category: 'Praseodymium-Neodymium Oxide',
      purity: '>22%>70%',
      shippingRoute: 'DDP China',
    },
    {
      category: 'Dysprosium Oxide',
      purity: '99.0-99.5%',
      shippingRoute: 'DDP China',
    },
    {
      category: 'Terbium Oxide',
      purity: '99.0-99.9%',
      shippingRoute: 'DDP China',
    },
  ],
}
